import { useContext } from 'react';

import { IntegrationContext } from '../context/integration';

export const useFormEnabled = () => {
  const context = useContext(IntegrationContext);

  if (context === null) {
    throw new Error('Must have integration context created');
  }

  return { enableForm: context.setFormEnabled };
};
